// Do not send recovery tokens, ticket tokens, order IDs or query parameters to GA.
export function analyticsPath(url: string): string {
  return (url.split(/[?#]/)[0] || '/')
    .replace(/^\/(r|tickets)\/[^/]+/, '/$1/[redacted]')
    .replace(/^\/checkout\/confirm\/[^/]+/, '/checkout/confirm/[redacted]');
}
